"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearChoiceTypography = void 0;
var common = __importStar(require("../../shared/typography"));
exports.clearChoiceTypography = [
    {
        props: common.heroXL.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.heroXLCommon), { fontFamily: 'Burgess Pro', fontWeight: 400, fontSize: '6.9375rem', lineHeight: '6.75rem', letterSpacing: '-1px', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '4rem',
                    lineHeight: '4rem',
                } }));
        },
    },
    {
        props: common.heroLarge.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.heroLargeCommon), { fontFamily: 'Burgess Pro', fontWeight: 400, fontSize: '4rem', lineHeight: '4rem', letterSpacing: '-1px', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '4rem',
                    lineHeight: '4rem',
                } }));
        },
    },
    {
        props: common.heroMedium.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.heroMediumCommon), { fontFamily: 'Burgess Pro', fontWeight: 400, fontSize: '3.3125rem', lineHeight: '3.5rem', letterSpacing: '-1px', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '2.5rem',
                    lineHeight: '2.5rem',
                } }));
        },
    },
    {
        props: common.header1.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.header1Common), { fontFamily: 'Burgess Pro', fontWeight: 400, fontSize: '2.375rem', lineHeight: '2.5rem', letterSpacing: '-0.5px', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '1.8125rem',
                    lineHeight: '2rem',
                } }));
        },
    },
    {
        props: common.header2.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.header2Common), { fontFamily: 'Burgess Pro', fontWeight: 400, fontSize: '1.9375rem', lineHeight: '2rem', letterSpacing: '-0.5px', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '1.5625rem',
                    lineHeight: '1.75rem',
                } }));
        },
    },
    {
        props: common.header3.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.header3Common), { fontFamily: 'Beausite Classic', fontWeight: 500, fontSize: '1.625rem', lineHeight: '2rem', letterSpacing: '-0.5px', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '1.375rem',
                    lineHeight: '1.5rem',
                    letterSpace: '0',
                } }));
        },
    },
    {
        props: common.header4.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.header4Common), { fontFamily: 'Beausite Classic', fontWeight: 500, fontSize: '1.375rem', lineHeight: '1.75rem', letterSpacing: '-0.5px', color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), '@media (max-width:600px)': {
                    fontSize: '1.25rem',
                    lineHeight: '1.5rem',
                    letterSpace: '0',
                } }));
        },
    },
    {
        props: common.badgeLabel.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.badgeLabelCommon), { fontFamily: 'Beausite Classic', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyXLBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyXLBookCommon), { fontFamily: 'Beausite Classic', fontWeight: 400, lineHeight: '1.75rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyLargeBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyLargeBookCommon), { fontFamily: 'Beausite Classic', fontWeight: 350, lineHeight: '1.875rem', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyLargeSemiBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyLargeSemiBoldCommon), { fontFamily: 'Beausite Classic', fontWeight: 500, lineHeight: '1.875rem', color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyLargeBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyLargeBoldCommon), { fontFamily: 'Beausite Classic', lineHeight: '1.875rem', color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyMediumBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyMediumBookCommon), { fontFamily: 'Beausite Classic', fontWeight: 350, lineHeight: '1.75rem', color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyMediumSemiBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyMediumSemiBoldCommon), { fontFamily: 'Beausite Classic', fontWeight: 500, lineHeight: '1.75rem', color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodyMediumBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodyMediumBoldCommon), { fontFamily: 'Beausite Classic', lineHeight: '1.75rem', color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodySmallBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodySmallBookCommon), { fontFamily: 'Beausite Classic', fontWeight: 350, lineHeight: '1.5rem', color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodySmallSemiBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodySmallSemiBoldCommon), { fontFamily: 'Beausite Classic', fontWeight: 500, lineHeight: '1.5rem', color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.bodySmallBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.bodySmallBoldCommon), { fontFamily: 'Beausite Classic', lineHeight: '1.5rem', color: "var(--text-primary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.captionLarge.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.captionLargeCommon), { fontFamily: 'Beausite Classic', fontWeight: 400, color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.captionMedium.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.captionMediumCommon), { fontFamily: 'Beausite Classic', fontWeight: 400, color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.chipLabel.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.chipLabelCommon), { fontFamily: 'Beausite Classic', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.errorValidation.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.errorValidationCommon), { fontFamily: 'Beausite Classic', color: theme.palette.error.dark }));
        },
    },
    {
        props: common.buttonLabel.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.buttonCommon), { fontFamily: 'Beausite Classic', fontWeight: 400, textTransform: 'none', color: theme.palette.text.interactive }));
        },
    },
    {
        props: common.overline.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.overlineCommon), { fontFamily: 'Beausite Classic', fontWeight: 700, letterSpacing: '1.5px', color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.lowestLevelBook.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.lowestLevelBookCommon), { fontFamily: 'Beausite Classic', fontWeight: 400, letterSpacing: 0, color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.lowestLevelSemiBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.lowestLevelSemiBoldCommon), { fontFamily: 'Beausite Classic', fontWeight: 500, letterSpacing: 0, color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.lowestLevelBold.props,
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common.lowestLevelBoldCommon), { fontFamily: 'Beausite Classic', letterSpacing: 0, color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")") }));
        },
    },
    {
        props: common.mainNavigationDefault.props,
        style: function (_a) {
            var theme = _a.theme;
            return ({
                fontFamily: 'Beausite Classic',
                fontSize: '0.75rem',
                fontWeight: 700,
                lineHeight: '1.25rem',
                letterSpacing: '0.03125rem',
                textTransform: 'uppercase',
                color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
            });
        },
    },
    {
        props: common.mainNavigationDefaultSubCategory.props,
        style: function (_a) {
            var theme = _a.theme;
            return ({
                fontFamily: 'Beausite Classic',
                fontSize: '0.75rem',
                fontWeight: 700,
                lineHeight: '1rem',
                letterSpacing: '0.0625rem',
                textTransform: 'uppercase',
                color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
            });
        },
    },
    {
        props: common.mainNavigationLight.props,
        style: function (_a) {
            var theme = _a.theme;
            return ({
                fontFamily: 'Beausite Classic',
                fontSize: '0.875rem',
                fontWeight: 350,
                lineHeight: '1.25rem',
                letterSpacing: 0,
                color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"),
            });
        },
    },
    {
        props: common.notification.props,
        style: function (_a) {
            var theme = _a.theme;
            return ({
                fontFamily: 'Beausite Classic',
                fontSize: '0.9375rem',
                lineHeight: '1.375rem',
                fontWeight: 350,
                color: "var(--text-secondary, ".concat(theme.palette.text.secondary, ")"),
            });
        },
    },
];
